import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import * as c from "./hamburgerMenu.module.scss";

const HamburgerMenu = ({ isActive, toggleActive, className }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.classList.toggle(c.active, isActive);
    }
  }, [isActive]);

  return (
    <button
      id="burger"
      ref={buttonRef}
      className={classNames(c.burgerContainer, className)}
      onClick={toggleActive}
      aria-label="Toggle the navigation"
    >
      <div className={`${c.burger} ${isActive ? c.active : ""}`}>
        <span>
          <span></span>
          <span></span>
        </span>
      </div>
    </button>
  );
};

export default HamburgerMenu;
